import { LifeRingTrigger } from 'components/ActionBar/LifeRing/LifeRingButton/LifeRingButton';
import { FlexColumnPanel } from 'components/secondaryMarket/shared/SidePanel/FlexColumnPanel';
import { ConnectedTradeWay } from 'components/secondaryMarket/shared/SidePanel/TradeWay.connect';
import { ActionButton, ButtonPanel } from 'components/secondaryMarket/shared/status';
import { ErrorPanelFooter, ErrorPanelHeader } from 'components/secondaryMarket/shared/status/Panel';
import { ConnectedHelpCenterButton } from 'components/shared/HelpCenter/HelpCenterButton';
import { FormattedMessage } from 'components/shared/Intl/FormattedMessage';
import { useSPIntl } from 'hooks/useIntl';
import { useToggleFeature } from 'hooks/useToggleFeature';
import type { IntlKey } from 'locales';
import { OrderActionType } from 'state/secondaryMarket/shared/actions';

type HelpCenterButtonOwnProps = Readonly<{
  className?: string;
}>;
function HelpCenterButton({ className }: HelpCenterButtonOwnProps) {
  const helpCenterEnhancement = useToggleFeature('helpCenterEnhancement');
  return helpCenterEnhancement ? (
    <div className={`d-flex ${className}`}>
      <ConnectedHelpCenterButton helpCenterId={ErrorSidePanel.name} />
    </div>
  ) : (
    <LifeRingTrigger e2e="SecondaryPanelContactUs-button" className={`d-flex ${className}`}>
      <button type="button" className="btn btn-default btn-xl m-1 w-100">
        <FormattedMessage id="lifeRing.helpRequest" />
        <em className="icon icon-outlined ms-1">live_help</em>
      </button>
    </LifeRingTrigger>
  );
}

type ErrorSidePanelProps = Readonly<{
  onDone: () => void;
  onQuote?: () => void;
  tabId: string;
  orderActionType: OrderActionType;
  errorMessage?: string | IntlKey;
  panelFooterMessageKey?: IntlKey;
  timeout?: number;
}>;

export function ErrorSidePanel({
  onDone,
  onQuote,
  tabId,
  orderActionType,
  errorMessage,
  timeout,
  panelFooterMessageKey = 'secondaryMarket.sidePanel.label.error',
}: ErrorSidePanelProps) {
  const { formatMessage } = useSPIntl();
  const newUxSidePanelWhenQuoteRejectedParis = orderActionType === 'LIVE' || orderActionType === 'LIMIT_ORDER';
  return (
    <FlexColumnPanel>
      <ErrorPanelHeader>
        <ConnectedTradeWay formId={tabId} />
        {formatMessage(
          { id: (errorMessage as IntlKey) ?? 'generic.error.message', defaultMessage: errorMessage },
          { timeInMillis: timeout },
        )}
      </ErrorPanelHeader>
      <ErrorPanelFooter statusKey={panelFooterMessageKey} />

      <div className="d-flex mt-auto mb-1 w-100">
        {!newUxSidePanelWhenQuoteRejectedParis && (
          <ActionButton
            color="discreet-secondary"
            label="secondaryMarket.sidePanel.label.ok"
            onClick={onDone}
            className="w-50"
          />
        )}
        <HelpCenterButton className={`${newUxSidePanelWhenQuoteRejectedParis ? 'w-100 m-1' : 'w-50'}`} />
      </div>
      {newUxSidePanelWhenQuoteRejectedParis && (
        <ButtonPanel className="w-100">
          <ActionButton
            color="primary"
            label={
              orderActionType === 'LIVE'
                ? 'secondaryMarket.sidePanel.label.quote'
                : 'secondaryMarket.sidePanel.label.placeLimitOrder'
            }
            disabled={false}
            onClick={onQuote}
          />
        </ButtonPanel>
      )}
    </FlexColumnPanel>
  );
}
